import { BaseBackendService } from './base-backend.service';
import { DigitalBusinessCard } from '../dbc/dbc.model';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QRCodeBuilder } from 'mobstac-awesome-qr';
import { CanvasType, QRErrorCorrectLevel } from 'mobstac-awesome-qr/lib/Enums';
import { ExternalUrlServiceService } from './external-url-service.service';
import { SsoAuthService } from './sso.service';

export enum QR_TEMPLATE {
    PLAIN_TEMPLATE = 'plain_template',
}

export enum LEAD_COLLECT_TYPE {
    COLLECT_FIRST = 1,
    SHARE_FIRST = 2,
}

@Injectable()
export class DbcService extends BaseBackendService<DigitalBusinessCard> {
    constructor(
        http: HttpClient,
        authService: AuthService,
        private externalURLService: ExternalUrlServiceService,
        ssoService: SsoAuthService
    ) {
        super(http, authService, DigitalBusinessCard, 'dbc', ssoService);
    }

    override post(body: object, custom?: string): Observable<any> {
        if (body instanceof DigitalBusinessCard) {
            body.clearModelForPost();
        }
        return super.post(body, custom);
    }

    override put(
        body: object,
        id: number | string,
        custom?: string
    ): Observable<any> {
        if (body instanceof DigitalBusinessCard) {
            body.clearModelForPut();
        }
        return super.put(body, id, custom);
    }

    generateDBCQrCode(dbc: DigitalBusinessCard) {
        let url = dbc?.url ? dbc.url : '';

        const {
            // @ts-ignore
            logoImage,
            logoHeight,
            backgroundColor,
            colorDark,
            colorLight,
            gradientType,
            frameStyle,
            frameText,
            // @ts-ignore
            logoBackground,
            backgroundImage,
            logoMargin,
            logoScale,
            rectangular,
            eyeFrameColor,
            eyeBallColor,
            // @ts-ignore
            eyeFrameShape,
            eyeBallShape,
            dataPattern,
            frameTextColor,
            frameColor,
            logoWidth,
        } = dbc?.template || {};

        const allAttributes = {
            logoImage,
            logoMargin,
            logoScale,
            rectangular,
            logoWidth,
            logoHeight,
            logoBackground,
            backgroundImage,
            backgroundColor,
            colorDark,
            colorLight,
            gradientType,
            frameStyle,
            frameText,
            frameColor,
            frameTextColor,
            dataPattern,
            eyeBallShape,
            eyeFrameShape,
            eyeBallColor,
            eyeFrameColor,
        };
        for (const key in allAttributes) {
            if (!allAttributes[key]) {
                delete allAttributes[key];
            }
        }

        const qRCodeGenerator = new QRCodeBuilder({
            ...allAttributes,
            text: url || 'https://www.uniqode.com',
            margin: 40,
            dotScale: 1,
            size: 480,
            canvasType: CanvasType.SVG,
            correctLevel: QRErrorCorrectLevel.H,
            imageServerURL: this.externalURLService.URL,
            imageServerRequestHeaders: {
                authorization: `${this.authService.getTokenType()} ${this.authService.getToken()}`,
            },
        });

        return qRCodeGenerator
            .build(CanvasType.SVG)
            .then((canvas) => {
                return canvas.svg;
            })
            .catch((err) => {
                console.error(err);
                return err;
            });
    }

    getPreviewHtml(url: string) {
        // Add custom headers
        // TODO: To be enabled once backend supports it on prod
        // const headers = new HttpHeaders().set('X-Insights-Redirect', 'none');
        return this.http.get(url, { responseType: 'text'});
    }
}
